module.exports = __webpack_public_path__ + "img/b3b06ce.png";